import Dialog from "components/ui/Dialog/Dialog";
import LoginForm from "features/authentication/components/LoginForm/LoginForm";

const LoginDialog = () => {
  return (
    <Dialog>
        <LoginForm/>
    </Dialog>
  )
}

export default LoginDialog;
